import React from "react";
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom";

import { Home, Request } from "components/pages";
import { RootUrlContext } from "containers/contexts";

const Routes = (match) => {
  return (
    <RootUrlContext.Provider value={match.url}>
      <RouterRoutes>
        <Route path="/" element={<Home />} />
        <Route
          path="/projects/:projectName/deployments/:deploymentName"
          element={<Request />}
        />
        <Route
          path="/projects/:projectName/deployments/:deploymentName/versions/:versionName"
          element={<Request />}
        />
        <Route
          path="/projects/:projectName/pipelines/:pipelineName"
          element={<Request />}
        />
        <Route
          path="/projects/:projectName/pipelines/:pipelineName/versions/:versionName"
          element={<Request />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </RouterRoutes>
    </RootUrlContext.Provider>
  );
};

export default Routes;
